export enum TypeOfCommentEnum {
  RECOMMENDATION = 'RECOMMENDATION',
  APPRECIATION = 'APPRECIATION',
  COMPLAINT = 'COMPLAINT',
}
